export default __webpack_public_path__ + "static/media/my-photo.fc938e21.jpg";